import { Component, OnInit } from '@angular/core';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { PageTitleService } from '../../services/page-title.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {  
  private pageHeader: string;  
  private selectionInfo: SelectionInfo;
  private isSelectionChanged: boolean;
  private selectEquipment: string;

  constructor(
    private pageTitleService: PageTitleService,
    private commonUtil: CommonUtil) { }

  ngOnInit(): void {
    this.pageTitleService.setTitle('');
  }

  private setPageHeader() {
    if(this.selectionInfo.activityId == '-1') {
      this.pageHeader = this.commonUtil.translateText('GENERAL.PRODUCT.SETTINGS');
    } else {
      if(this.selectionInfo.activityId === "2" || this.selectionInfo.activityId === "3"){
        this.pageHeader = `${this.commonUtil.translateText('EQ.TYPE.LONG.' + this.selectionInfo.activityId)} ${this.commonUtil.translateText('PRODUCT.SETTINGS')}`;
      }else{
        this.pageHeader = `${this.commonUtil.translateText('EQ.TYPE.' + this.selectionInfo.activityId)} ${this.commonUtil.translateText('PRODUCT.SETTINGS')}`;
      }      
    }
  }

  private onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      this.selectEquipment = selectionInfo.activityId;
      this.setPageHeader();
      // inform children that selection has changed to handle refreshing the data
      this.isSelectionChanged = true;
    });    
    // unset the flag after the next cycle
    setTimeout(() => this.isSelectionChanged = false);
  }
}
